import styled from '@emotion/styled';
import Button from '@ep/components/Button';
import theme from '@ep/theme';
import { Gcms_Asset } from '@ep/types/gatsbyTypes';
import CloseIcon from '@mui/icons-material/Close';
import Fade from '@mui/material/Fade';
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';
import React, { HTMLAttributes } from 'react';
import Media from '../Media';

export interface ButtonProps extends HTMLAttributes<HTMLDivElement> {
  label?: string;
  link: string;
}

const CloseModal = styled.div`
  position: absolute;
  right: 1rem;
  top: 1rem;
  z-index: 10;
`;

const StyledButton = styled(Button)`
  outline: none;
`;

const StyledModal = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalContainer = styled.div`
  width: 90vw;
  background-color: ${theme.colors.black};
  outline: none;
`;

const VideoButton = ({ label, link }: ButtonProps) => {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <StyledButton
        onClick={() => setOpen(true)}
        icon="Play"
        label={label}
        size="large"
      />
      <StyledModal open={open} onClose={() => setOpen(false)}>
        <Fade in={open}>
          <ModalContainer>
            <CloseModal>
              <IconButton aria-label="close" onClick={() => setOpen(false)}>
                <CloseIcon htmlColor={theme.colors.white} />
              </IconButton>
            </CloseModal>
            <Media
              media={{ url: link, vidyardLink: link } as Gcms_Asset}
              aspectRatio={16 / 9}
            />
          </ModalContainer>
        </Fade>
      </StyledModal>
    </>
  );
};

export default VideoButton;
